
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'V2CancelSubscriptionModal',
  props: {
    processing: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close(): void {
      if (this.processing) return
      this.$emit('close')
    }
  }
})
